import type { KeyDatePage } from '@edwin-group/people-graphql';
import { CalendarDropdown } from '@/pages/key-dates/shared/components/calendar-dropdown';
import { keyDateToCalendarEvent } from '../../utils/key-date-to-calendar-event';
import { formatKeyDateBadgeSplit } from '../../utils/format-key-date';
import type { KeyDate } from '../../types';
import { getKeyDateTags } from '../../types';

interface KeyDateCardProps {
  keyDate: KeyDate;
  showAddToCalendar?: boolean;
  page?: KeyDatePage | null;
}

export const KeyDateCard = ({ keyDate, showAddToCalendar = true, page }: KeyDateCardProps) => {
  const calendarEvent = keyDateToCalendarEvent(keyDate);
  const { date } = formatKeyDateBadgeSplit(keyDate);
  const tags = getKeyDateTags(keyDate.sectionType, keyDate.topicLabel);

  return (
    <div className="flex h-full flex-col justify-between rounded-[6px] border border-[#40B0AC] bg-[#F4F9F8]">
      <div className="flex flex-col gap-2  p-4">
        <div className="flex items-start justify-between">
          <div className=" rounded-2xl bg-white p-[9px]">
            <div className="flex flex-col text-sh-xs font-normal text-dark-green ">{date}</div>
          </div>
        </div>

        <h3 className="!mb-0 font-haffer text-sh-xxs font-bold text-gray-900">{keyDate.title}</h3>

        {tags.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {tags.map((tag) => (
              <div
                key={tag}
                className="flex items-center justify-center rounded-[8px] border border-dashed border-[#40B0AC] bg-white px-3 py-[6px]">
                <span className="text-sh-xxxs font-normal">{tag}</span>
              </div>
            ))}
          </div>
        )}

        {keyDate.description && (
          <p className="line-clamp-2 text-sh-xxs font-normal text-gray-600">{keyDate.description}</p>
        )}

        <div className="flex flex-col gap-2">
          {showAddToCalendar && keyDate.startDate && <CalendarDropdown event={calendarEvent} page={page} />}
          {keyDate.bookYourPlaceUrl && (
            <a
              href={keyDate.bookYourPlaceUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-left font-haffer text-sh-xxxs font-bold !text-people-teal-600 hover:opacity-50">
              {page?.bookYourPlaceLabel}
            </a>
          )}
          {keyDate.learnMoreUrl && (
            <a
              href={keyDate.learnMoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-left font-haffer text-sh-xxxs font-bold !text-people-teal-600 hover:opacity-50">
              {page?.learnMoreLabel}
            </a>
          )}
        </div>
      </div>

      {keyDate.dateType === 'deadline' && (
        <div className="rounded-b-[6px] border bg-download-icon px-4 py-2">
          <span className="font-haffer font-bold text-black">{page?.deadlineLabel}</span>
        </div>
      )}
    </div>
  );
};
